import { useEffect, useState } from 'react';

import { clamp, formatDuration, isDefined, SECOND } from '@enterprise/core';

import { heartbeatThresholdMs } from '@/constants/session-config';
import { useApplicationStore } from '@hooks/application/application-store.hook';

import type { HeartbeatStatus } from '../types/heartbeat-status.type';

export const useHeartbeatTimerConfiguration = () => {
  const lastValidatedAt = useApplicationStore(({ lastValidatedAt }) => {
    return lastValidatedAt;
  });

  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, SECOND);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const elapsedMs = isDefined(lastValidatedAt) ? Math.max(0, now - lastValidatedAt) : null;
  const percentage = isDefined(elapsedMs) ? clamp(Math.min((elapsedMs / heartbeatThresholdMs) * 100, 100), 0, 100) : 0;
  const label = isDefined(elapsedMs) ? `${formatDuration(elapsedMs, { showHours: false })} ago` : '—';
  const status: HeartbeatStatus = percentage >= 80 ? 'danger' : percentage >= 50 ? 'warning' : 'safe';

  return { label, percentage, status };
};
